import Vue from 'vue'

// 导入 当前目录的所有 组件
const ctx = require.context('./', false, /\.vue$/)
ctx.keys().forEach((key) => {
  const c = ctx(key).default
  const name = key.replace(/^\.\//, '').replace(/\.vue$/, '')
  Vue.component(name, c)
})
